import { Tab, TabProps } from "@mui/material";
import { COLORS } from "config/theme";

const StyledTab = (props: TabProps) => {
  return <Tab {...props} sx={{ color: COLORS.foskek, fontWeight: "600", backgroundColor: "white", "&.Mui-selected": { fontWeight: "bold" } }} />;
};

export default StyledTab;
